import TyPicker from './TyPicker.vue'
export default TyPicker



// WEBPACK FOOTER //
// ./src/components/ty-picker/index.js